import React from 'react';
import clsx from 'clsx';

import { Form, FormSubmitHandler } from 'components/Form';
import { ModalHeader } from 'components/ModalHeader/ModalHeader';
import { MODAL_ID } from 'components/Modal.const';
import { getLastFooterElement } from 'util/ModalForm.util';

import styles from 'components/ModalForm.module.scss';

export type StackedFormProps = Readonly<{
  onSubmit: FormSubmitHandler;
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string;
  className?: string;
}>;

/***
 * Form with header, content, and footer.
 * NOTE: to take advantage of the standard bottom tray footer styles, the last child must be a `footer` element
 *
 * @example
 * <Form>
 *   <div />
 *   <div />
 *   <footer />
 * </Form>
 */
export const StackedForm: React.FC<StackedFormProps> = ({
  title, onSubmit, className, children
}) => {
  const contents = React.Children.toArray(children);

  const last = getLastFooterElement(contents);

  return (
    <Form className={clsx(styles.container, className)} onSubmit={onSubmit} autoScrollToError={true}>
      {title && <ModalHeader id={MODAL_ID}>{title}</ModalHeader>}
      <section className={styles.body} data-testId={'MAIN_BODY'}>
        {last ? contents.slice(0, contents.length - 1) : children}
      </section>
      {last && React.cloneElement(last, { className: clsx(styles.bottomTray, last.props.className) })}
    </Form>
  );
};
